import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Button } from "primereact/button";
import { Dropdown } from "primereact/dropdown";
import { classNames } from "primereact/utils";
import { useCallback, useContext, useEffect, useLayoutEffect, useRef, useState } from "react";
import { Controller, useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { useNavigate, useOutletContext } from "react-router-dom";
import { FormInput } from "../../components/FormInput";
import { FormInputFile } from "../../components/FormInputFile";
import { FormTextarea } from "../../components/FormTextarea";
import ImagePDFComponent from "../../components/ImagePDFComponent";
import { useEditableFlag } from "../../hooks/useEditableFlag";
import { checkLoading, SystemLoading } from "../../store/loadingStore";
import { handleSuccessMessage, MessageContext } from "../../store/messageStore";
import { AlertService } from "../../utility/service/alert-service";
import { getSubItemsByItemNo } from "../../utility/service/api-service";
import {
  createCompanyOffering,
  F1040402Before,
  getCBAMSubItemsByItemNo,
  UpdateCompanyOffering,
} from "../../utility/service/companyOffering-service";
import { checkDpSuccess, getFileBase64, splitFileExtension, splitFileName } from "../../utility/service/tool-service";
import { addFormValidator } from "../../utility/validate/formValidator";

const CompanyOffering_Create = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const { itemObj, setItemObj, action, setAction, currentComSeq, currentCompanyName } = useOutletContext();
  const [editAction, setEditAction] = useState("");
  const fileInputRef = useRef();
  const flowFileInputRef = useRef();
  const [previewUrl, setPreviewUrl] = useState(null);
  const [flowPreviewUrl, setFlowPreviewUrl] = useState(null);
  const [zoomSrc, setZoomSrc] = useState(null);
  const [flowZoomSrc, setFlowZoomSrc] = useState(null);
  const [fileInfo, setFileInfo] = useState({});
  const [flowFileInfo, setFlowFileInfo] = useState({});
  const [unitCodeList, setUnitCodeList] = useState([]);
  const [formRule, setFormRule] = useState([]); //表單驗證
  const [productTypeList, setProductTypeList] = useState([]);
  const [enableFlagList, setEnableFlagList] = useState([]);
  const [, loading] = useContext(SystemLoading);
  const [, dispatch] = useContext(MessageContext); //訊息視窗
  const [cnCodeList, setCnCodeList] = useState([]);
  const isEditable = useEditableFlag("F10404"); // Get editable status for F10404 function

  const {
    register,
    handleSubmit,
    watch,
    clearErrors,
    getValues,
    setValue,
    resetField,
    reset: resetForm,
    control,
    trigger,
    reset,
    formState: { errors, isValid, isDirty },
  } = useForm({
    defaultValues: {
      enableFlag: "Y",
    },
    //錯誤驗證時機
    mode: "all",
  });

  const btnBackTo = () => {
    navigate("/management/companyOffering");
  };

  const inputCheckKeyDown = (e) => {
    //避免觸發 按enter 後 就觸發 onSubmit 事件冒泡 給input 使用 <FormInput enterClick事件 ; 一般input onKeyDown事件
    if (e.key === "Enter") {
      e.preventDefault();
    }
  };

  useLayoutEffect(() => {
    axios_CoefficientUnitList();
  }, []);

  useEffect(() => {
    if (action !== "") {
      setEditAction(action);
      axios_getCreateBefore();
    } else {
      btnBackTo();
    }
  }, [action]);

  useEffect(() => {
    if (JSON.stringify(itemObj) !== "{}") {
      setValue("productType", itemObj?.productType);
      setValue("productName", itemObj?.productName);
      setValue("productEName", itemObj?.productEName);
      setValue("declaringUnit", itemObj?.declaringUnit);
      setValue("functionalUnit", itemObj?.functionalUnit);
      setValue("enableFlag", itemObj?.enableFlag);
      setValue("hsCode", itemObj?.hsCode);
      setValue("cnCode", itemObj?.cnCode);
      setValue("technicalDescription", itemObj?.technicalDescription);
      setValue("productIntroduction", itemObj?.productIntroduction);
      if (itemObj?.fileId) {
        setValue("fileName", itemObj?.fileName);
        setValue("fileExtension", itemObj?.fileExtension);
        setValue("filePic", itemObj?.filePathSml);
      }

      if (itemObj?.flowFileId) {
        setValue("flowFileName", itemObj?.flowFileName);
        setValue("flowFileExtension", itemObj?.flowFileExtension);
        setValue("flowFilePic", itemObj?.flowFilePathSml);
      }

      if (itemObj?.fileExtension !== null) {
        // setPreviewUrl(editObj?.devicePic);
        setZoomSrc(itemObj?.filePath); //原圖
        if (itemObj?.fileExtension === "pdf") {
          setPreviewUrl(itemObj?.filePath); //原圖
        } else {
          setPreviewUrl(itemObj?.filePathSml); //縮圖
        }
        setFileInfo({
          type: itemObj?.fileExtension,
          name: `${itemObj?.fileName}.${itemObj?.fileExtension}`,
        });
      }

      if (itemObj?.flowFileExtension !== null) {
        // setPreviewUrl(editObj?.devicePic);
        setFlowZoomSrc(itemObj?.flowFilePath); //原圖
        if (itemObj?.flowFileExtension === "pdf") {
          setFlowPreviewUrl(itemObj?.flowFilePath); //原圖
        } else {
          setFlowPreviewUrl(itemObj?.flowFilePathSml); //縮圖
        }
        setFlowFileInfo({
          type: itemObj?.flowFileExtension,
          name: `${itemObj?.flowFileName}.${itemObj?.flowFileExtension}`,
        });
      }
    }
  }, [itemObj]);

  const onSubmit = (data) => {
    checkLoading(loading);
    const formData = new FormData();
    let filePic = data.filePic !== undefined && data.filePic !== "" ? data.filePic : null;
    let fileId = itemObj?.fileId === undefined ? null : itemObj?.fileId;
    let flowFilePic = data.flowFilePic !== undefined && data.flowFilePic !== "" ? data.flowFilePic : null;
    let flowFileId = itemObj?.flowFileId === undefined ? null : itemObj?.flowFileId;
    formData.append("companySeq", currentComSeq);
    formData.append("productType", data.productType);
    formData.append("productName", data.productName);
    formData.append("productEName", data.productEName);
    formData.append("declaringUnit", data.declaringUnit);
    formData.append("enableFlag", data.enableFlag);
    if (data.functionalUnit) {
      formData.append("functionalUnit", data.functionalUnit);
    }
    if (data.hsCode) {
      formData.append("hsCode", data.hsCode);
    }
    if (data.cnCode) {
      formData.append("cnCode", data.cnCode);
    }
    if (data.technicalDescription) {
      formData.append("technicalDescription", data.technicalDescription);
    }
    if (data.productIntroduction) {
      formData.append("productIntroduction", data.productIntroduction);
    }

    if (fileId === null && filePic !== null) {
      //新增
      formData.append("filePic", fileInputRef.current?.files[0]);
      formData.append("fileName", data.fileName);
      formData.append("fileExtension", data.fileExtension);
    } else if (fileId !== null && fileInputRef.current?.files[0] !== undefined) {
      //更新
      formData.append("fileId", fileId);
      formData.append("filePic", fileInputRef.current?.files[0]);
      formData.append("fileName", data.fileName);
      formData.append("fileExtension", data.fileExtension);
    } else if ((data.filePic === null || data.filePic === "" || data.filePic === undefined) && fileId !== null) {
      //刪除
      formData.append("fileId", fileId);
    }

    if (flowFileId === null && flowFilePic !== null) {
      //新增
      formData.append("flowFilePic", flowFileInputRef.current?.files[0]);
      formData.append("flowFileName", data.flowFileName);
      formData.append("flowFileExtension", data.flowFileExtension);
    } else if (flowFileId !== null && flowFileInputRef.current?.files[0] !== undefined) {
      //更新
      formData.append("flowFileId", flowFileId);
      formData.append("flowFilePic", flowFileInputRef.current?.files[0]);
      formData.append("flowFileName", data.flowFileName);
      formData.append("flowFileExtension", data.flowFileExtension);
    } else if (
      (data.flowFilePic === null || data.flowFilePic === "" || data.flowFilePic === undefined) &&
      flowFileId !== null
    ) {
      //刪除
      formData.append("flowFileId", flowFileId);
    }

    if (action === "create") {
      createCompanyOffering(formData)
        .then((res) => {
          if (checkDpSuccess(res)) {
            handleSuccessMessage(dispatch, t("button.create") + " " + t("message.success"));
            btnBackTo();
          }
        })
        .finally((fin) => {
          checkLoading(loading, false);
        });
    } else {
      formData.append("offeringsId", itemObj?.offeringsId);
      UpdateCompanyOffering(formData)
        .then((res) => {
          if (checkDpSuccess(res)) {
            handleSuccessMessage(dispatch, t("button.update") + " " + t("message.success"));
            btnBackTo();
          }
        })
        .finally((fin) => {
          checkLoading(loading, false);
        });
    }
  };

  const handleFileChange = (e) => {
    //每次開啟選擇檔案觸發onChange事件
    if (e.target.files[0]) {
      if (e.target.files[0].size >= 20000000) {
        AlertService.ok("Error", "Size over 20MB");
        setPreviewUrl(null);
        setZoomSrc(null);
        setValue("fileExtension", ""); //副檔名
        setValue("fileName", ""); //檔名
        setValue("filePic", "");
        setFileInfo({});
        fileInputRef.current.value = null;
      } else {
        setPreviewUrl(URL.createObjectURL(e.target.files[0]));
        setZoomSrc(URL.createObjectURL(e.target.files[0]));

        let fileExtension = splitFileExtension(e.target.files[0]?.name);
        setValue("fileExtension", fileExtension); //副檔名
        setValue("fileName", splitFileName(e.target.files[0]?.name));
        setFileInfo(e.target.files[0]);

        // 測試用 ↓
        getFileBase64(e.target.files[0]).then((result) => {
          setValue("filePathSml", result);
          setValue("filePath", result);
        });
        // 測試用 ↑
        setValue("filePic", e.target.files[0], { shouldValidate: true }); //檔案格式 原圖 如果轉為MulitPart 需解開此
      }
    }
  };

  const handleFlowFileChange = (e) => {
    //每次開啟選擇檔案觸發onChange事件
    if (e.target.files[0]) {
      if (e.target.files[0].size >= 20000000) {
        AlertService.ok("Error", "Size over 20MB");
        setFlowPreviewUrl(null);
        setFlowZoomSrc(null);
        setValue("flowFileExtension", ""); //副檔名
        setValue("flowFileName", ""); //檔名
        setValue("flowFilePic", "");
        setFlowFileInfo({});
        flowFileInputRef.current.value = null;
      } else {
        setFlowPreviewUrl(URL.createObjectURL(e.target.files[0]));
        setFlowZoomSrc(URL.createObjectURL(e.target.files[0]));

        let fileExtension = splitFileExtension(e.target.files[0]?.name);
        setValue("flowFileExtension", fileExtension); //副檔名
        setValue("flowFileName", splitFileName(e.target.files[0]?.name));
        setFlowFileInfo(e.target.files[0]);

        // 測試用 ↓
        getFileBase64(e.target.files[0]).then((result) => {
          setValue("flowFilePathSml", result);
          setValue("flowFilePath", result);
        });
        // 測試用 ↑
        setValue("flowFilePic", e.target.files[0], { shouldValidate: true }); //檔案格式 原圖 如果轉為MulitPart 需解開此
      }
    }
  };

  const handleDeleteImg = () => {
    //刪除圖片
    if (fileInputRef?.current?.value !== undefined) {
      fileInputRef.current.value = null;
      setPreviewUrl(null);
      setZoomSrc(null);
      setValue("fileExtension", ""); //副檔名
      setValue("fileName", ""); //檔名
      setValue("filePic", "");
    }
  };

  const handleFlowDeleteImg = () => {
    //刪除圖片
    if (flowFileInputRef?.current?.value !== undefined) {
      flowFileInputRef.current.value = null;
      setFlowPreviewUrl(null);
      setFlowZoomSrc(null);
      setValue("flowFileExtension", ""); //副檔名
      setValue("flowFileName", ""); //檔名
      setValue("flowFilePic", "");
    }
  };

  const axios_CoefficientUnitList = () => {
    getSubItemsByItemNo("COEFFICIENT_UNIT", 27).then((res) => {
      if (checkDpSuccess(res)) {
        let data = res.data.RespBody.subItems;
        let newArray = data.map((item, index) => {
          return {
            ...item,
            index: index,
          };
        });
        setUnitCodeList(newArray);
      }
    });

    getSubItemsByItemNo("ENABLE_STATUS", 18).then((res) => {
      if (checkDpSuccess(res)) {
        let data = res.data.RespBody.subItems;
        let newArray = data.map((item, index) => {
          return {
            ...item,
            index: index,
          };
        });
        setEnableFlagList(newArray);
      }
    });

    getSubItemsByItemNo("PRODUCT_TYPE", 31).then((res) => {
      if (checkDpSuccess(res)) {
        let data = res.data.RespBody.subItems;
        let newArray = data.map((item, index) => {
          return {
            ...item,
            index: index,
          };
        });
        setProductTypeList(newArray);
      }
    });

    //CBAN list
    getCBAMSubItemsByItemNo("CBAM_CNC", 3).then((res) => {
      if (checkDpSuccess(res)) {
        let data = res.data.RespBody.subItems;
        let newArray = data.map((item, index) => {
          return {
            ...item,
            index: index,
          };
        });
        setCnCodeList(newArray);
      }
    });
  };

  //建立前查詢form 規則
  const axios_getCreateBefore = () => {
    F1040402Before().then((res) => {
      if (checkDpSuccess(res)) {
        let array = [];
        res?.data?.RespBody?.constraints?.forEach((item) => {
          const result = addFormValidator(item?.field, res.data.RespBody.constraints);
          array.push(result);
        });
        setFormRule(array);
      }
    });
  };

  const setValidForm = useCallback(
    (formId) => {
      if (formRule?.length > 0) {
        const tmp = formRule?.find((item) => {
          return Object.keys(item)[0] === formId;
        });
        return tmp ? tmp[formId] : "";
      }
    },
    [formRule]
  );

  return (
    <>
      {/* 返回上頁 */}
      <div className="flex justify-content-between flex-wrap align-items-center">
        <div className="align-items-start">
          <Button
            rounded
            text
            onClick={() => {
              btnBackTo();
            }}
          >
            <FontAwesomeIcon icon="fa-solid fa-arrow-left-long" />
            {t("button.return_to_list")}
          </Button>
        </div>
        <div className="align-items-end">{t(`button.${editAction}`)}</div>
      </div>

      {/* 上方廠商基本資訊(create 時不顯示) */}
      <div className="p-card bg-gray">
        <div className="p-card-body">
          <div className="grid align-items-center">
            <div className="col-10">
              <h3 className="m-0">{currentCompanyName}</h3>
            </div>
          </div>
        </div>
      </div>

      <form onSubmit={handleSubmit(onSubmit)}>
        <div className="p-card">
          <div className="p-card-body">
            <div className="grid" style={{ overflowX: "hidden" }}>
              {/* 中文名稱 */}
              <div className="col-12">
                <FormInput
                  labelClass="required"
                  withLabel={true}
                  register={register}
                  errors={errors}
                  id="productName"
                  labelText={t("productName")}
                  type="text"
                  disabled={editAction === "detail" || !isEditable}
                  enterClick={inputCheckKeyDown}
                  rules={setValidForm("productName")}
                />
              </div>
              {/* 英文名稱 */}
              <div className="col-12">
                <FormInput
                  labelClass="required"
                  withLabel={true}
                  register={register}
                  errors={errors}
                  id="productEName"
                  labelText={t("enName")}
                  type="text"
                  disabled={editAction === "detail" || !isEditable}
                  enterClick={inputCheckKeyDown}
                  rules={setValidForm("productEName")}
                />
              </div>
              {/* 狀態 */}
              <div className="col-12 lg:col-4">
                <label htmlFor="enableFlag" className="form-label required">
                  {t("status")}
                </label>
                <Controller
                  name="enableFlag"
                  control={control}
                  rules={setValidForm("enableFlag")}
                  render={({ field, fieldState }) => (
                    <Dropdown
                      optionLabel="subitemName"
                      optionValue="subitemNo"
                      disabled={editAction === "detail" || !isEditable}
                      appendTo={"self"}
                      value={field.value}
                      virtualScrollerOptions={{ itemSize: 40 }}
                      defaultValue={""}
                      placeholder={t("plz_chs")}
                      name="enableFlag"
                      control={control}
                      options={enableFlagList}
                      className={`w-full ` + classNames({ "p-invalid": fieldState.error })}
                      onChange={(event) => {
                        field.onChange(event.value);
                      }}
                    />
                  )}
                />
              </div>
              {/* 類型 */}
              <div className="col-12 lg:col-4">
                <label htmlFor="productType" className="form-label required">
                  {t("type")}
                </label>
                <Controller
                  name="productType"
                  control={control}
                  rules={setValidForm("productType")}
                  render={({ field, fieldState }) => (
                    <Dropdown
                      disabled={editAction === "detail" || !isEditable}
                      optionLabel="subitemName"
                      optionValue="subitemNo"
                      appendTo={"self"}
                      value={field.value}
                      virtualScrollerOptions={{ itemSize: 40 }}
                      defaultValue={""}
                      placeholder={t("plz_chs")}
                      name="productType"
                      control={control}
                      options={productTypeList}
                      className={`w-full ` + classNames({ "p-invalid": fieldState.error })}
                      onChange={(event) => {
                        field.onChange(event.value);
                      }}
                    />
                  )}
                />
              </div>
              {/* 宣告單位 */}
              <div className="col-12 lg:col-4">
                <label htmlFor="declaringUnit" className="form-label required">
                  {t("declareUnit")}
                </label>
                <Controller
                  name="declaringUnit"
                  control={control}
                  rules={setValidForm("declaringUnit")}
                  render={({ field, fieldState }) => (
                    <Dropdown
                      filter
                      optionLabel="subitemName"
                      optionValue="subitemNo"
                      disabled={editAction === "detail" || !isEditable}
                      appendTo={"self"}
                      value={field.value}
                      virtualScrollerOptions={{ itemSize: 40 }}
                      defaultValue={""}
                      placeholder={t("plz_chs")}
                      name="declaringUnit"
                      control={control}
                      options={unitCodeList}
                      className={`w-full ` + classNames({ "p-invalid": fieldState.error })}
                      onChange={(event) => {
                        field.onChange(event.value);
                      }}
                    />
                  )}
                />
              </div>
              {/* 功能單位 */}
              <div className="col-12 lg:col-4">
                <label htmlFor="functionalUnit" className="form-label">
                  {t("functionalUnit")}
                </label>
                <Controller
                  name="functionalUnit"
                  control={control}
                  // rules={setValidForm("functionalUnit")}
                  render={({ field, fieldState }) => (
                    <Dropdown
                      filter
                      showClear
                      optionLabel="subitemName"
                      optionValue="subitemNo"
                      disabled={editAction === "detail" || !isEditable}
                      appendTo={"self"}
                      value={field.value}
                      virtualScrollerOptions={{ itemSize: 40 }}
                      defaultValue={""}
                      placeholder={t("plz_chs")}
                      name="functionalUnit"
                      control={control}
                      options={unitCodeList}
                      className={`w-full ` + classNames({ "p-invalid": fieldState.error })}
                      onChange={(event) => {
                        field.onChange(event.value);
                      }}
                    />
                  )}
                />
              </div>
              {/* HS Code */}
              <div className="col-12 lg:col-4">
                <FormInput
                  labelClass=""
                  withLabel={true}
                  register={register}
                  errors={errors}
                  id="hsCode"
                  labelText="HS Code"
                  type="text"
                  disabled={editAction === "detail" || !isEditable}
                  enterClick={inputCheckKeyDown}
                  rules={setValidForm("hsCode")}
                />
              </div>
              {/* CN Code */}
              <div className="col-12 lg:col-4">
                <label htmlFor="cnCode" className="form-label">
                  CN Code
                </label>
                <Controller
                  name="cnCode"
                  control={control}
                  rules={setValidForm("cnCode")}
                  render={({ field, fieldState }) => (
                    <Dropdown
                      tooltip={cnCodeList?.find((item) => item?.subitemNo === field?.value)?.subitemName || ""}
                      tooltipOptions={{ position: "bottom" }}
                      filter
                      showClear
                      optionLabel="subitemName"
                      optionValue="subitemNo"
                      disabled={editAction === "detail" || !isEditable}
                      value={field.value}
                      virtualScrollerOptions={{ itemSize: 40 }}
                      defaultValue={""}
                      placeholder={t("plz_chs")}
                      control={control}
                      options={cnCodeList}
                      className={`w-full ` + classNames({ "p-invalid": fieldState.error })}
                      onChange={(event) => {
                        field.onChange(event.value);
                      }}
                    />
                  )}
                />
              </div>
              {/* 技術描述 */}
              <div className="col-12">
                <FormTextarea
                  register={register}
                  errors={errors}
                  id="technicalDescription"
                  name="technicalDescription"
                  type="text"
                  labelText={t("technicalDes")}
                  areaClass="w-full"
                  disabled={editAction === "detail" || !isEditable}
                  rules={setValidForm("technicalDescription")}
                />
              </div>
              {/* 產品介紹與特性描述*/}
              <div className="col-12">
                <FormTextarea
                  register={register}
                  errors={errors}
                  id="productIntroduction"
                  name="productIntroduction"
                  type="text"
                  labelText={t("productIntroduction")}
                  areaClass="w-full"
                  disabled={editAction === "detail" || !isEditable}
                />
              </div>
              {/* 產品圖片 */}
              <div className="col-12 lg:col-6">
                <label htmlFor="filePic" className="form-label">
                  {t("productPic")}
                </label>
                <div
                  className="grid"
                  style={{
                    minHeight: `${editAction === "detail" ? "160px" : "calc(160px - 0.6rem)"}`,
                  }}
                >
                  {/* 檢視不能選檔案 */}
                  {editAction === "detail" ? (
                    <></>
                  ) : (
                    <div className={`col-12 ${previewUrl ? "lg:col-7" : ""}`}>
                      <FormInputFile
                        wrapperStyle={{ padding: "0.7rem" }}
                        disabled={editAction === "detail" || !isEditable}
                        register={register}
                        errors={errors}
                        acceptFileType=".jpg,.png"
                        id="filePic"
                        name="filePic"
                        limitSize="5MB"
                        fileChange={(e) => {
                          handleFileChange(e);
                        }}
                        rules={{
                          required: {
                            value: false,
                            message: t("validation.required"),
                          },
                        }}
                        fileInputRef={fileInputRef}
                      />
                    </div>
                  )}

                  {previewUrl && (
                    <div className={`col-12 ${previewUrl ? "lg:col-5" : ""}`}>
                      <ImagePDFComponent
                        disabled={editAction === "detail" || !isEditable}
                        wrapperClass=""
                        file={fileInfo}
                        previewUrl={previewUrl}
                        zoomSrc={zoomSrc}
                        imgWidth="140"
                        imgHeight="140"
                        deleteImg={handleDeleteImg}
                      />
                    </div>
                  )}
                </div>
              </div>
              {/* 產品製作流程圖 */}
              <div className="col-12 lg:col-6">
                <label htmlFor="filePic" className="form-label">
                  {t("productFlowPic")}
                </label>
                <div
                  className="grid"
                  style={{
                    minHeight: `${editAction === "detail" ? "160px" : "calc(160px - 0.6rem)"}`,
                  }}
                >
                  {/* 檢視不能選檔案 */}
                  {editAction === "detail" ? (
                    <></>
                  ) : (
                    <div className={`col-12 ${flowPreviewUrl ? "lg:col-7" : ""}`}>
                      <FormInputFile
                        wrapperStyle={{ padding: "0.7rem" }}
                        disabled={editAction === "detail" || !isEditable}
                        register={register}
                        errors={errors}
                        acceptFileType=".jpg,.png"
                        id="flowFilePic"
                        name="flowFilePic"
                        limitSize="5MB"
                        fileChange={(e) => {
                          handleFlowFileChange(e);
                        }}
                        rules={{
                          required: {
                            value: false,
                            message: t("validation.required"),
                          },
                        }}
                        fileInputRef={flowFileInputRef}
                      />
                    </div>
                  )}

                  {flowPreviewUrl && (
                    <div className={`col-12 ${flowPreviewUrl ? "lg:col-5" : ""}`}>
                      <ImagePDFComponent
                        disabled={editAction === "detail" || !isEditable}
                        wrapperClass=""
                        file={flowFileInfo}
                        previewUrl={flowPreviewUrl}
                        zoomSrc={flowZoomSrc}
                        imgWidth="140"
                        imgHeight="140"
                        deleteImg={handleFlowDeleteImg}
                      />
                    </div>
                  )}
                </div>
              </div>
            </div>

            {editAction === "create" ? (
              <div className="col-12 gap-2 flex-all-center">
                <Button
                  disabled={!(isValid && isDirty) || !isEditable}
                  type="submit"
                  label={t("button.confirm")}
                  size="small"
                />
                <Button
                  outlined
                  size="small"
                  type="button"
                  label={t("button.cancel")}
                  onClick={(e) => {
                    e.preventDefault();
                    btnBackTo();
                  }}
                />
              </div>
            ) : (
              <>
                {editAction === "detail" ? (
                  <div className="col-12 gap-2 flex-all-center">
                    <Button
                      disabled={!isEditable}
                      label={t("button.edit")}
                      onClick={(e) => {
                        e.preventDefault();
                        setEditAction("update");
                      }}
                      type="button"
                      size="small"
                    />
                  </div>
                ) : (
                  <div className="col-12 gap-2 flex-all-center">
                    <Button disabled={!isValid || !isEditable} type="submit" label={t("button.confirm")} size="small" />
                    <Button
                      outlined
                      size="small"
                      type="button"
                      label={t("button.cancel")}
                      onClick={(e) => {
                        e.preventDefault();
                        setEditAction("detail");
                        btnBackTo();
                      }}
                    />
                  </div>
                )}
              </>
            )}
          </div>
        </div>
      </form>
    </>
  );
};

export default CompanyOffering_Create;
